import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import Pages
import Home from '../pages/Home';
import UnsereMission from '../pages/UnsereMission';
import Projekte from '../pages/Projekte';
import Kontakt from '../pages/Kontakt';
import Impressum from '../pages/Impressum';
import Datenschutz from '../pages/Datenschutz';
import VisKar from './VisKar';
// import VcQr from './VcQr'; // 
import NotFoundPage from './NotFoundPage';

const AnimRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/index.html' element={<Home />} />
      <Route path='/UnsereMission' element={<UnsereMission />} />
      <Route path='/Projekte' element={<Projekte />} />
      <Route path='/Kontakt' element={<Kontakt />} />
      <Route path='/Impressum' element={<Impressum />} />
      <Route path='/Datenschutz' element={<Datenschutz />} />
      <Route path='/VisKar' element={<VisKar />} />

      {/* إعادة توجيه رابط/QR إلى الصفحة الرئيسية مع استبدال الإدخال في السجل */}
      <Route path='/VcQr' element={<Navigate to='/' replace />} />

      {/* احتفظ بصفحة 404 للمسارات الأخرى */}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
}

export default AnimRoutes;
